import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import Settings from './Setting';
import Common from './Common';
import Dashboard from './Dashboard';
import Wall from './Wall';
import PageKKP from './PageKKP';
import TaskManagement from './TaskManagement';
import Repository from './Repository';
import KM from './KnowledgeManagement';
import Kebijakan from './Kebijakan';
import TitleTree from './TitleTree';
import KlasifikasiArip from './KlasifikasiArsip';
import Employee from './Pegawai';
import Personal from './Personal';
import Divisi from './Divisi';
import KMmyPost from './KnowledgeManagementMyPost';
import kmAdminReducer from './KnowledgeManagementAdmin';
import portalReducer from './Portal';
import dataTableReducer from './admintools/dataTable';
import admintoolsReducer from './admintools/Admintools';
import KMSummary from './KMAdminSummary';
import ChatApp from './ChatApp';
import profileReducer from './Profile';
import profileAdmintoolsReducer from './admintools/Profile';
import titleAdmintoolsReducer from './admintools/Jabatan';
import roleReducer from './Role';
import setModeAppReducers from './ModeApp';
import EventManagement from './EventManagement';
import digitalSignReducer from './DigitalSign';
import agendaBersamaReducer from './AgendaBersama';
import divisonAdmintoolsReducer from './admintools/Division';
import departmentAdmintoolsReducer from './admintools/Department';
import kmAdmintoolsReducer from './admintools/Km';
import notatindakanAdmintoolsReducer from './admintools/NotaTindakan';
import jobsAdmintoolsReducer from './admintools/Jobs';
import SequenceReducer from './admintools/Sequence';
import PenomoranReducer from './admintools/Penomoran';
import Survey from './Survey';
import aksiPerubahanReducer from './AksiPerubahan';
import kalenderPersonalReducer from './KalenderPersonal';
import kalenderSatkerReducer from './KalenderSatker';
import presensiReducer from './Presensi';
import groupAddressbookReducer from './admintools/GroupAddressbook';
import faqAdmintoolsReducer from './Faq';
import kepegawaianReducer from './Kepegawaian';
// import fileReportReducer from './admintools/FileReport';
import kopSuratReducer from './admintools/KopSurat';
import ProdukHukumReducer from './ProdukHukum';
import NotulensiReducer from './Notulensi';
import ProgramKerjaReducer from './ProgramKerja';
import PengaturanNotifikasiReducer from './PengaturanNotifikasi';
import bpkdriveReducer from './BPKDrive';

const reducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    common: Common,
    dashboard: Dashboard,
    aksiPerubahan: aksiPerubahanReducer,
    wall: Wall,
    pageKKP: PageKKP,
    taskManagement: TaskManagement,
    repository: Repository,
    km: KM,
    kebijakan: Kebijakan,
    titleTree: TitleTree,
    klasifikasiArsip: KlasifikasiArip,
    employee: Employee,
    personal: Personal,
    divisi: Divisi,
    divisiAdmintools: divisonAdmintoolsReducer,
    departmentAdmintools: departmentAdmintoolsReducer,
    kmAdmintools: kmAdmintoolsReducer,
    notatindakanAdmintools: notatindakanAdmintoolsReducer,
    kmmypost: KMmyPost,
    kmAdmin: kmAdminReducer,
    jobsAdmintools: jobsAdmintoolsReducer,
    portal: portalReducer,
    dataTable: dataTableReducer,
    admintools: admintoolsReducer,
    kmsummary: KMSummary,
    chatApp: ChatApp,
    profile: profileReducer,
    jabatan: titleAdmintoolsReducer,
    faq: faqAdmintoolsReducer,
    pegawai: profileAdmintoolsReducer,
    role: roleReducer,
    appMode: setModeAppReducers,
    role: roleReducer,
    em: EventManagement,
    digiSign: digitalSignReducer,
    agendaBersama: agendaBersamaReducer,
    kalenderPersonal: kalenderPersonalReducer,
    kalenderSatker: kalenderSatkerReducer,
    sequence: SequenceReducer,
    penomoran: PenomoranReducer,
    survey: Survey,
    presensi: presensiReducer,
    groupAddr: groupAddressbookReducer,
    kepegawaian: kepegawaianReducer,
    // fileReport:fileReportReducer,
    kopSurat: kopSuratReducer,
    produkHukum: ProdukHukumReducer,
    notulensi: NotulensiReducer,
    programKerja: ProgramKerjaReducer,
    pengaturanNotifikasi: PengaturanNotifikasiReducer,
    bpkdrive: bpkdriveReducer,
  });

export default reducers;
